window.showDeleteParticipantModal = function(participantName, programName, deleteFnc )
{
	$("#delete_participant_modal #participant_name").html(participantName);
	$("#delete_participant_modal #program_name").html(programName);
	$("#delete_participant_modal #delete_btn").attr('onclick', deleteFnc);
	$("#delete_participant_modal #program_name").removeClass('form-control');
	$("#delete_participant_modal").modal('show');
};

window.showUserUpgradeModal = function (participantName, url){
    $('#upgrade_participant_modal #participant_name').html(participantName);
    $('#upgrade_participant_modal #upgrade_url').attr('href', url);

    $('#upgrade_participant_modal').modal('show');
}

window.deleteParticipantFromProgram = function(participantId, programId)
{
	const requestUrl = $('#delete_participant_modal #delete_btn').attr('data-route');
	const redirectUrl = $('#delete_participant_modal #delete_btn').attr('data-redirect');

	$.ajax({
		url: requestUrl,
		method: "delete",
		data: { participant_id: participantId, program_id: programId }
	}).done(function (response) {
		location.href = redirectUrl;
	})
}

var oldLanguageId;
window.editParticipant = function editParticipant(participantId, requestUrl) {
    var programId = $("#program_id").val();

    oldLanguageId = $("#language").val();
    $.ajax({
        url: requestUrl,
        method: "GET",
        data: { program_id: programId, user_id: participantId }
    }).done(function (response) {
        var participant = response.data;

        $("input[name='id']").val(participant._Id);
        $("#email").val(participant._Email);
        $("#first_name").val(participant._FirstName);
        $("#last_name").val(participant._LastName);
        $("#middle_initial").val(participant._MiddleInitial);
        $("#job_title").val(participant._JobTitle);
        $('#is_anonymous').attr('checked', participant._IsAnonymous);
        $('#language').find('option').removeAttr('selected');
        $("select[name='language_id']" ).val(participant._LanguageId);

        $("#invalid-user-error").hide().html('');
        $('#add_participant_success_msg').parent().hide();
        $("#addParticipant").text("Save Participant");
        $("#cancelParticipantEditing").removeClass("d-none");
        $('#editingParticipant').val('1');

        $('label[for="is_anonymous"]').focus();
    });
};

var programOldCompletionEmail, programOldBccPractitioner, programOldIsAutoScore, programOldLanguageId, programOldDemographics, programOldMandatoryDemographics, programOldUseAltEmail, programAssessmentType;
window.editProgramSummary = function editProgramSummary(programId, url) {
    $('#overlay').remove();
    $('.summary-icons').html(
        '<button type="button" class="border-0 bg-transparent save-summary-icon" ' +
        'id="saveProgramIcon" ' +
        'data-program-id="' + programId + '" ' +
        'data-route="' + url + '" ' +
        'aria-label="Save Program" ' +
        'onkeydown="if (event.keyCode === 13) { $(\'#saveProgramIcon\').click(); }">' +
        '<i class="fas fa-save pointer save-icon-font" aria-hidden="true"></i>' +
        '</button>' +

        '<button type="button" class="border-0 bg-transparent reset-summary-icon ml-2" ' +
        'id="resetProgramIcon" ' +
        'data-program-id="' + programId + '" ' +
        'data-route="' + url + '" ' +
        'aria-label="Cancel Changes" ' +
        'onkeydown="if (event.keyCode === 13) { event.preventDefault(); event.stopPropagation(); $(\'#resetProgramIcon\').click(); }">' +
        '<i class="fas fa-backspace pointer save-icon-font" aria-hidden="true"></i>' +
        '</button>'
    );
    $('#program_alt_email, #program_name, #program_description, #program_alt_email').attr('contenteditable', 'true');
    $('#program_description, #program_alt_email').addClass('form-control');
    $('.summary-wrapper input[type="radio"], input[type="checkbox"], select[name="language"]').removeAttr('disabled');

    var overlay = jQuery('<div id="overlay"> </div>');
    overlay.appendTo(document.body);
    $('#program-summary').addClass('program-overlay');

    // defining hidden elem to store old values to restore them when user closed the editable without saving
    $("body").append($("<div></div>").addClass("d-none").attr("id", "#programOld").append($("<div></div>").attr("id", "programOldName").html($("#program_name").text().trim()), $("<div></div>").attr("id", "programOldDescription").html($("#program_description").text().trim()), $("<div></div>").attr("id", "programOldAltEmail").html($("#program_alt_email").text().trim())));

    programOldUseAltEmail = $("input[name='use_alt_email']:checked").val();
    programOldCompletionEmail = $("input[name='receive_completion_email']:checked").val();
    programOldBccPractitioner = $("input[name='bcc_practitioner']:checked").val();
    programOldDemographics = $("input[name='demographics']:checked").val();
    programOldMandatoryDemographics = $("input[name='demographics_required']:checked").val();
    programOldIsAutoScore = $("input[name='is_auto_score']:checked").val();
    programOldLanguageId = $("select[name='language']").val();
};

window.editProgramName = function editProgramName(programId, url) {
    $('#overlay').remove();
    $('#editProgramNameIcon').html(
        '<button type="button" class="border-0 bg-transparent p-0 save-summary-icon" ' +
        'id="saveProgramIcon" ' +
        'data-program-id="' + programId + '" ' +
        'data-route="' + url + '" ' +
        'aria-label="Save Program Name" ' +
        'onkeydown="if (event.keyCode === 13) { $(\'#saveProgramIcon\').click(); }">' +
        '<i class="fas fa-save pointer save-icon-font" aria-hidden="true"></i>' +
        '</button>' +
        '<button type="button" class="border-0 bg-transparent p-0 reset-summary-icon ml-2" ' +
        'id="resetProgramNameIcon" ' +
        'data-program-id="' + programId + '" ' +
        'data-route="' + url + '" ' +
        'aria-label="Cancel Changes" ' +
        'onkeydown="if (event.keyCode === 13) { event.preventDefault(); event.stopPropagation(); $(\'#resetProgramNameIcon\').click(); }">' +
        '<i class="fas fa-backspace pointer save-icon-font" aria-hidden="true"></i>' +
        '</button>'
    );
    $('#program_name').attr('contenteditable', 'true');
    $('#program_name').addClass('form-control');

    var overlay = jQuery('<div id="overlay"> </div>');
    overlay.appendTo(document.body);
    $('#program_name_container').addClass('program-overlay');

    $("body").append($("<div></div>").addClass("d-none").attr("id", "#programOld").append($("<div></div>").attr("id", "programOldName").html($("#program_name").text().trim())));
};

window.editProgramDetail = function editProgramDetail(programId, url) {

    $('#overlay').remove();

    $('#programDetailsIcons').html(
        '<button type="button" class="border-0 bg-transparent p-0" ' +
        'id="saveProgramDetailsIcon" ' +
        'data-route="' + url + '" ' +
        'data-program-id="' + programId + '" ' +
        'aria-label="Save Program Details" ' +
        'onkeydown="if (event.keyCode === 13) { $(\'#saveProgramDetailsIcon\').click(); }">' +
        '<i class="fas fa-save pointer save-icon-font" aria-hidden="true" title="Save Program Details"></i>' +
        '</button>' +

        '<button type="button" class="border-0 bg-transparent p-0 ml-2" ' +
        'id="resetProgramDetailsIcon" ' +
        'data-route="' + url + '" ' +
        'data-program-id="' + programId + '" ' +
        'aria-label="Cancel Changes" ' +
        'onkeydown="if (event.keyCode === 13) { event.preventDefault(); event.stopPropagation(); $(\'#resetProgramDetailsIcon\').click(); }">' +
        '<i class="fas fa-backspace pointer save-icon-font" aria-hidden="true" title="Cancel Changes"></i>' +
        '</button>'
    );

    var overlay = jQuery('<div id="overlay"> </div>');
    overlay.appendTo(document.body);
    $(".prg_details").addClass('d-none');
    $("#prg_details_form").removeClass('d-none');
    $('#program-detail').addClass('program-overlay');
};

$(document).on('click', "#resetProgramIcon", function (ev) {
    var programId = $("#program_id").val();
    var url = $(this).attr('data-route');
    $("#overlay").remove();
    $('.summary-icons').html('<i class="fa fa-edit pointer" title="Edit Program Summary" onclick="editProgramSummary(\'' + programId + '\',\'' + url + '\')"></i>');
    $("#program-summary").removeClass("program-overlay");

    // reset name and description fields text
    $("#program_name").text($("#programOldName").text().trim());
    $("#program_description").text($("#programOldDescription").text().trim());
    $("#program_alt_email").text($("#programOldAltEmail").text().trim());
    $("input[name='receive_completion_email'][value='" + programOldCompletionEmail + "']").prop("checked", true);
    $("input[name='bcc_practitioner'][value='" + programOldBccPractitioner + "']").prop("checked", true);
    $("input[name='is_auto_score'][value='" + programOldIsAutoScore + "']").prop("checked", true);
    $("input[name='demographics'][value='" + programOldDemographics + "']").prop("checked", true);
    $("input[name='use_alt_email'][value='" + programOldUseAltEmail + "']").prop("checked", true);
    $("select[name='language']").val(programOldLanguageId);

    if (programOldMandatoryDemographics === '1') {
        $("input[name='demographics_required'][value='" + programOldMandatoryDemographics + "']").prop("checked", true);
    } else {
        $("input[name='demographics_required'][value='1']").removeAttr("checked");
    }

    $("[contenteditable=true]").attr("contenteditable", false);
    $("[contenteditable]").removeClass("form-control");
    $('.summary-wrapper input[type="radio"], input[type="checkbox"], select[name="language"]').attr('disabled', 'disabled');
});

$(document).on('click', "#resetProgramNameIcon", function (ev) {
    ev.stopPropagation(); // STOP the event from bubbling up
    ev.preventDefault();  // PREVENT default behavior

    var $element = $("#resetProgramNameIcon");
    var programId = $("#program_id").val();
    var url = $element.attr('data-route');
    $("#overlay").remove();

    // Use setTimeout to delay creating the new button
    setTimeout(function() {
        $('#editProgramNameIcon').html('<i class="fa fa-edit pointer" title="Edit Program Name" onclick="editProgramName(\'' + programId + '\',\'' + url + '\')"></i>');
    }, 50); // Wait 50 milliseconds

    $("#program_name_container").removeClass("program-overlay");
    document.getElementById('program_name_container').classList.remove('program-overlay');

    // reset name and description fields text
    $("#program_name").text($("#programOldName").text().trim());

    $("[contenteditable=true]").attr("contenteditable", false);
    $("[contenteditable]").removeClass("form-control");
});

$(document).on('click', "#resetProgramDetailsIcon", function (ev) {
    var programId = $("#program_id").val();
    var url = $(this).attr('data-route');
    $("#overlay").remove();
    $('#programDetailsIcons').html('<span id="editDetailIcon"><i class="fa fa-edit pointer" title="Edit Program Details" onclick="editProgramDetail(\'' + programId + '\',\'' + url + '\')"></i></span>');
    $(".prg_details").removeClass('d-none');
    $("#prg_details_form").addClass('d-none');

    $("#program-detail").removeClass("program-overlay");
});

$(document).on("click", "#saveProgramIcon", function () {

    var url = $(this).attr('data-route');
    var programName = $("#program_name").text().trim(),
        programDescription = $("#program_description").text().trim(),
        programId = $("#program_id").val(),
        programAltEmail = $("#program_alt_email").text().trim(),
        programCompletionEmail = $("input[name='receive_completion_email']:checked").val(),
        bccPractitioner = $("input[name='bcc_practitioner']:checked").val(),
        programIsAutoScore = $("input[name='is_auto_score']:checked").val(),
        programLanguageId = $("select[name='language']").val(),
        programDemographics = $("input[name='demographics']:checked").val() || true,
        programDemographicsRequired = $("input[name='demographics_required']:checked").val() || false;
    programAssessmentType = $("input[name='assessment_type_id']").val();

    $.ajax({
        url: url,
        method: "put",
        data: {
            name: programName,
            description: programDescription,
            id: programId,
            alt_email: programAltEmail,
            receive_completion_email: programCompletionEmail,
            is_auto_score: programIsAutoScore,
            language_id: programLanguageId,
            demographics: programDemographics,
            demographics_required: programDemographicsRequired,
            assessment_type_id: programAssessmentType,
            bcc_practitioner: bccPractitioner
        }
    }).done(function (response) {
        window.location.reload();
    });
});

$(document).on("click", "#saveProgramDetailsIcon", function () {
    var url = $(this).attr('data-route');
    var startDate = $("#prg_start_date").val(),
        endDate = $("#prg_end_date").val(),
        assessmentTypeId = $("#program_assessment_type").val(),
        programId = $("#program_id").val(),
        status = $("#program_status_id").val();

    $.ajax({
        type: 'PUT',
        url: url,
        data: {
            start_date: startDate,
            end_date: endDate,
            assessment_type_id: assessmentTypeId,
            id: programId,
            status: status
        },
        success: function success(response) {
            if (response.status) {
                window.location.reload();
            } else {
                console.log('ERROR: ' + response.message);
            }
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            $("#save_spinner").addClass('d-none');
            // Log the error to the console
            console.error("The following error occurred: " + textStatus, errorThrown);
        }
    });
});

/* Demographics required disabling */
$('#demographicsOff').on('change', function (e) {
    $("#demographicsRequired").prop("checked", false);
    $("#demographicsRequired").attr("disabled", true);
});

$('#demographicsOn').on('change', function (e) {
    $("#demographicsRequired").prop("checked", false);
    $("#demographicsRequired").attr("disabled", false);
});

$( "#cancelParticipantEditing" ).on("click", function () {
    let form = $("#addParticipantForm");

    form.trigger("reset");
    form.find( "select option" ).removeAttr( "selected" );
    form.find( "input[name='id']" ).val('');
    form.find( "input[name='is_anonymous']" ).removeAttr('checked');
    form.find( "select[name='language_id']" ).val(oldLanguageId);

    $( "#addParticipant" ).text( "Add Participant" );
    $( "#editingParticipant").val('0');
    $( "#cancelParticipantEditing" ).addClass( "d-none" );
});
